import { type ReactNode } from 'react';
import TopBar from '@/components/feature/TopBar';
import Navbar from '@/components/feature/Navbar';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTopButton from '@/components/feature/ScrollToTopButton';

interface SiteLayoutProps {
  children: ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="w-full min-h-screen flex flex-col bg-background-50">
      <TopBar />
      <Navbar />
      <main className="w-full flex-1">{children}</main>
      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}